/*****************************************
  APLP UPSELL MODAL - LOGICA
  Tipo Cine Colombia - ApoloPets Edition
******************************************/

console.log('%c[APLP] Upsell modal JS cargado', 'color:#3cb371; font-weight:bold;');

(function () {

  /* ================================
      REFERENCIAS BÁSICAS
  ================================= */
  const overlay = document.getElementById("aplp-upsell-overlay");
  const modal = document.getElementById("aplp-upsell-modal");

  if (!overlay || !modal) {
    console.warn("[APLP] Modal de upsell no encontrado.");
    return;
  }

  const btnClose = document.getElementById("aplp-upsell-close");
  const btnContinue = document.getElementById("aplp-upsell-continue");
  const btnCheckout = document.getElementById("aplp-upsell-checkout");

  const btnPrev = document.getElementById("aplp-upsell-prev");
  const btnNext = document.getElementById("aplp-upsell-next");

  const slider = document.getElementById("aplp-upsell-products");

  let currentTranslate = 0;
  const cardWidth = 196; // 180 + 16px gap (del CSS)
  const step = cardWidth;

  /* ==================================
      1) MOSTRAR / OCULTAR MODAL
  =================================== */

  window.openUpsellModal = function () {
    overlay.style.display = "flex";

    setTimeout(() => {
      overlay.style.opacity = 1;
    }, 10);

    document.body.style.overflow = "hidden";
  };

  function closeUpsellModal() {
    overlay.style.opacity = 0;
    setTimeout(() => {
      overlay.style.display = "none";
      document.body.style.overflow = "";
    }, 200);
  }

  btnClose?.addEventListener("click", closeUpsellModal);

  /* 
     IMPORTANTE:
     Antes este botón solo cerraba el modal.
     Ahora SOLO lo usaremos para cerrar si el usuario quiere cerrar sin redirigir.
  */
  // btnContinue?.addEventListener("click", closeUpsellModal);

  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeUpsellModal();
  });

  /* ==================================
      2) SLIDER LATERAL (Cine Colombia)
  =================================== */

  function slideNext() {
    currentTranslate -= step;
    const maxTranslate = -(slider.children.length * step - slider.parentElement.clientWidth);

    if (currentTranslate < maxTranslate) {
      currentTranslate = maxTranslate;
    }

    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  function slidePrev() {
    currentTranslate += step;
    if (currentTranslate > 0) currentTranslate = 0;
    slider.style.transform = `translateX(${currentTranslate}px)`;
  }

  btnNext?.addEventListener("click", slideNext);
  btnPrev?.addEventListener("click", slidePrev);

  /* ==================================
      3) AGREGAR PRODUCTOS DESDE EL MODAL
  =================================== */

  document.querySelectorAll(".aplp-upsell__add-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      const variantId = this.dataset.variantId;

      if (!variantId) return console.error("[APLP] Variante no encontrada para agregar.");

      this.innerHTML = "Añadiendo...";
      this.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(() => {
          this.innerHTML = "Agregado ✓";

          setTimeout(() => {
            this.innerHTML = "Agregar";
            this.disabled = false;
          }, 1200);
        })
        .catch(err => {
          console.error("[APLP] Error agregando upsell:", err);
          this.innerHTML = "Error";
        });
    });
  });

  /* ==================================
      4) IR AL CHECKOUT
  =================================== */
  btnCheckout?.addEventListener("click", () => {
    window.location.href = "/checkout";
  });

  /* ============================================================
      5) PUNTO 3 — SEGUIR EXPLORANDO (REDIRECCIÓN AUTOMÁTICA)
     ============================================================ */

  document.addEventListener("DOMContentLoaded", function () {
    const btnContinue = document.getElementById("aplp-upsell-continue");
    const modal = document.getElementById("aplp-upsell-modal");

    if (modal && btnContinue) {
      const collectionURL = modal.dataset.collection || "/collections/all";

      btnContinue.addEventListener("click", function () {
        window.location.href = collectionURL;
      });
    }
  });

})();
